import React from 'react';
import './UnfilledButton.css';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { fetchDownloadableFileApi } from '../../../../api/OutilsApi';

function UnfilledButton({
  children,
  bgColor = 'var(--main-color)',
  hoverColor = 'var(--white)',
  fontSize = '1rem',
  padding = '5px 20px',
  onClick,
  to,
  type = 'button',
  className = '',
  target = '_self',
  rel = '',
  disabled = false,
  borderRadius = '10px',
  download = false,
}) {
  async function downloadFile(e) {
    e.preventDefault();

    try {
      const response = await fetchDownloadableFileApi(to);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'CONDUIRE_UN_ENTRETIEN_AVEC_L_EXPLOITANT_D_UNE_AFFAIRE.pdf');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  }

  return (
    <>
      {to && !download ? (
        to.includes('#') ? (
          <HashLink
            smooth
            className={`button unfilled-button ${className} ${disabled ? 'disabled' : ''}`}
            style={{
              '--color': bgColor,
              '--hover-color': hoverColor,
              '--font-size': fontSize,
              '--padding': padding,
              '--border-radius': borderRadius,
            }}
            onClick={e => {
              onClick && onClick(e);
            }}
            rel={rel}
            to={to}>
            {children}
          </HashLink>
        ) : (
          <Link
            className={`button unfilled-button ${className} ${disabled ? 'disabled' : ''}`}
            style={{
              '--color': disabled ? 'var(--grey)' : bgColor,
              '--font-size': fontSize,
              '--hover-color': hoverColor,
              '--padding': padding,
              '--border-radius': borderRadius,
            }}
            onClick={e => {
              onClick && onClick(e);
            }}
            to={to}
            target={target}>
            {children}
          </Link>
        )
      ) : (
        <button
          type={type}
          className={'button unfilled-button ' + className}
          style={{
            '--color': bgColor,
            '--font-size': fontSize,
            '--hover-color': hoverColor,
            '--padding': padding,
            '--border-radius': borderRadius,
          }}
          onClick={e => {
            if (!disabled) {
              onClick && onClick(e);
              download && downloadFile(e);
            }
          }}>
          {children}
        </button>
      )}
    </>
  );
}

export default UnfilledButton;
